import { fontSize } from "@/util/common/fontSize";
import echarts from 'echarts';

function getItemStyle(item) {
    let piValue = item.piValue;
    let limitValue = item.limitValue;
    let rate = piValue / limitValue * 100;
    //console.log(rate)
    let color = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 0, color: '#2CFFC7' },
        { offset: 0.5, color: '#2CFFC7' },
        { offset: 1, color: 'rgba(63,193,255,0.26)' }
    ])
    if (rate > 80) {
        color = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 1, color: '#FFD53F' },
            { offset: 0, color: '#FFD953' }
        ])
    }
    if(rate >= 100) {
        color = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 1, color: '#FFFFFF' },
            { offset: 0, color: '#FF0029' }
        ])
    }
    return {
        color: color,
        barBorderRadius: [px16,px16,px16,px16]
    }
}

let px16 = fontSize(16);
export function getOption(data, xAxisData) {
    return {
        grid: {
            top: fontSize(50),
            bottom: fontSize(40),
            left: fontSize(30)
        },
        tooltip: {},
        xAxis: [
            {
                type: 'category',
                data: xAxisData,
                axisLine: {
                    show: false // 刻度
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: "#fff",
                    rotate: 45,
                    fontSize: fontSize(14),
                    formatter: function (value, index) {
                        return value.substring(0,3);
                    }
                }
            }
        ],
        yAxis: [
            {
                type: 'value',
                name: 'mg/m³',
                nameTextStyle: {
                    color: "#fff"
                },
                axisLine: {
                    show: false
                },
                axisLabel: {
                    color: "#fff",
                    fontSize: fontSize(14)
                },
                splitLine: {
                    lineStyle: {
                        color: "rgba(255,255,255,0.1)"
                    }
                }
            }
        ],
        series: [
            {
                type: 'bar',
                barWidth: fontSize(12),
                data: data.map(item => {
                    return {
                        ...item,
                        value: item.piValue,
                        itemStyle: getItemStyle(item)
                    }
                })
            }
        ]
    }
}